/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { HelpRequestAttachmentDto, HelpRequestDto } from '@gh/builder-shared-data';
import { toString } from '@gh/core-util';
import { first, padStart } from 'lodash';

export type HelpRequest = HelpRequestDto;
export type HelpRequestAttachment = HelpRequestAttachmentDto;

function stringifyDateComponent(n: number): string {
  return padStart(toString(n), 2, '0'); // tslint:disable-line:no-magic-numbers
}

export function getScreenshotName(date: Date): string {
  return [
    [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(stringifyDateComponent).join('-'),
    [date.getHours(), date.getMinutes(), date.getSeconds()].map(stringifyDateComponent).join('-'),
    'Screenshot.png',
  ].join('_');
}

export function getHelpRequestScreenshot(request: HelpRequest): Maybe<HelpRequestAttachment> {
  return first(request.attachments);
}
